// extracted by mini-css-extract-plugin
module.exports = {"dark":"divider-m__dark__AWCua","light":"divider-m__light__3y6_3"};